import { dataStore, runtime } from './runtime';

type ReactiveElement = BaseElement & {
    option?: number;
    setOption?: string;
    label?: Element;
};

const componentRegistry: Record<string, () => BaseElement> = {
    Language: () => new Language(),
    Step: () => new Step()
};

function createReactiveElement(name: string): ReactiveElement {
    const factory = componentRegistry[name];

    if (!factory) {
        throw new Error('Unknown data-mod handler: ' + name);
    }

    return factory() as ReactiveElement;
}

export class Elements {
    public dropdown: Dropdown[];
    public input: Input[];
    public steps: { actual: number; options: Step[]; conditions: string[]; };
    public language: Language;

    constructor() {
        this.dropdown = [];
        this.steps = { actual: 0, options: [], conditions: [] };
        this.input = [];

        $('.restart').on('click', () => this.setActualStep(-1));
    }

    public addSteps(step: Step) {
        this.steps.options.push(step);
    }

    public setActualStep(index: number) {
        if (this.steps.options[index] !== undefined && index > this.steps.actual) {
            this.steps.actual = index;
            this.refreshSteps();
            return;
        }

        if (index === -1 && !runtime.query.parameters.parametersExist()) {
            $(this.steps.options[0].label).html(this.steps.options[0].labelOriginal);
            $(this.steps.options[0].parent).removeClass('active');
            this.steps.actual = 0;
            this.refreshSteps();
        }
    }

    public refreshSteps() {
        $.each(this.steps.options, (index, step) => {
            if (this.steps.actual >= step.option - 1) {
                $(step.parent).removeClass('deactive');
            } else {
                if (!$(step.parent).hasClass('deactive')) {
                    $(step.parent).addClass('deactive');
                }

                if ($(step.parent).hasClass('active')) {
                    $(step.parent).removeClass('active');
                }

                if (!$(step.parent).hasClass('last')) {
                    $(step.label).html(step.labelOriginal);
                }

                step.setOption = '';
            }
            this.steps.conditions[(step.option || 1) - 1] = step.setOption;
        });

        if (this.getStepByOption(1) !== undefined) {
            this.renderVersionOptions();
        }

        $('#describe').children().each((index, element) => {
            if (!$(element).hasClass('step' + (this.steps.actual + 1))) {
                if (!$(element).hasClass('hide')) {
                    $(element).addClass('hide');
                }
            } else {
                $(element).removeClass('hide');
            }
        });
    }

    public addDropdown(dropdown: Dropdown) {
        this.dropdown.push(dropdown);
    }

    public buildHelpHref(): string | undefined {
        const version = this.getSelectedStepValue(1);

        if (typeof version !== 'string' || version.length === 0) {
            return undefined;
        }

        return '/' + version + runtime.query.parameters.link;
    }

    public resetStepsAfter(option: number) {
        $.each(this.steps.options, (index, step) => {
            if (step.option > option) {
                $(step.parent).removeClass('active filled');
                $(step.label).html(step.labelOriginal);
                $(step.element).addClass('hide');
                $(step.parent).siblings('.arrow-box').removeClass('up');
                $(step.parent).children('.arrow-box').removeClass('up');
                step.setOption = '';
            }
        });
    }

    private getStepByOption(option: number): Step | undefined {
        return this.steps.options.find((step) => step.option === option);
    }

    private getSelectedStepValue(option: number): string {
        return this.getStepByOption(option)?.setOption || '';
    }

    private getRequestedValues(value: string | string[] | undefined): string[] {
        if (value === undefined || value === 'last') {
            return [];
        }

        return typeof value === 'string' ? [value] : value;
    }

    private renderVersionOptions() {
        const versionStep = this.getStepByOption(1);
        const versions = dataStore.value;

        if (versionStep === undefined || versions === undefined) {
            return;
        }

        const list = $(versionStep.element);
        const requestedVersions = this.getRequestedValues(runtime.query.parameters.version);

        list.children(':not(#no-data-version)').remove();

        let hasVersion = false;
        for (const version in versions) {
            const matchesRequestedVersion = requestedVersions.length === 0 || requestedVersions.indexOf(version) !== -1;

            if (!matchesRequestedVersion || versions[version] !== true) {
                continue;
            }

            hasVersion = true;
            $('<li data-value="' + version + '"><a href="#">' + version + '</a></li>').appendTo(list);
        }

        list.off('click.version-option').on('click.version-option', 'li[data-value], li[data-value] a', (event) => versionStep.onClick(event));

        if (!hasVersion) {
            $('#no-data-version').removeClass('hide');
            return;
        }

        $('#no-data-version').addClass('hide');

        const visibleVersions = list.children('li[data-value]');
        if (visibleVersions.length === 1 && runtime.query.parameters.parametersExist() && versionStep.setOption.length === 0) {
            visibleVersions.first().trigger('click');
        }
    }

    public checkUnDropdown(event: Event) {
        const target = event.target as Element | null;

        $.each(this.dropdown, (index, dropdown) => {
            if (target !== dropdown.react.label && !$(target).hasClass('language-text')) {
                const element = $(dropdown.react.element);
                if (!element.hasClass('hide')) {
                    element.addClass('hide');
                    $(dropdown.element).siblings('.arrow-box').removeClass('up');
                    $(dropdown.element).children('.arrow-box').removeClass('up');
                }
            }
        });
    }

    public addInput(input: Input) {
        this.input.push(input);
    }

    public setLanguage(language: Language) {
        this.language = language;
    }
}

export class BaseElement {
    public element: Element;

    constructor(element?: Element) {
        if (element !== undefined) {
            this.element = element;
            $(this.element).on('click', () => this.onClick());
        }
    }

    public setElement(element: Element) {
        this.element = element;
        this.afterSet();
    }

    public afterSet() {
    }

    public afterLoad() {
    }

    public onClick(event: any = null) {
    }
}

export class Dropdown extends BaseElement {
    public react: ReactiveElement;

    constructor(element: Element) {
        super(element);

        const componentName = this.element.attributes.getNamedItem('data-mod')?.value || '';
        this.react = createReactiveElement(componentName);
        this.react.setElement($(this.element).find('.dropdown').get(0));
    }

    public onClick() {
        const element = $(this.react.element);

        if ($(this.element).hasClass('filled')) {
            return;
        }

        if (element.hasClass('hide')) {
            if (this.react instanceof Step) {
                if (runtime.elements.steps.actual >= (this.react.option || 0) - 1) {
                    $(this.element).siblings('.arrow-box').addClass('up');
                    $(this.element).children('.arrow-box').addClass('up');
                    element.removeClass('hide');
                }

                return;
            }

            $(this.element).siblings('.arrow-box').addClass('up');
            $(this.element).children('.arrow-box').addClass('up');
            element.removeClass('hide');
            return;
        }

        element.addClass('hide');
        $(this.element).siblings('.arrow-box').removeClass('up');
        $(this.element).children('.arrow-box').removeClass('up');
        runtime.elements.refreshSteps();
    }
}

export class Input extends BaseElement {
    public baseText: string;
    public target: Element;
    public parent: Element;
    public react: ReactiveElement;
    public list: Element;

    constructor(element: Element) {
        super(element);

        this.target = $(this.element).find('input')[0];
        this.baseText = String($(this.target).val() || '');
        this.parent = $(this.element).parent()[0];

        const componentName = this.element.attributes.getNamedItem('data-mod')?.value || '';
        this.react = createReactiveElement(componentName);
        this.react.setElement($(this.element).children('input').get(0));

        this.list = $(this.element).find('.list-item').get(0);

        $(this.target).focusin(() => this.focusIn());
        $(this.target).focusout(() => this.focusOut());
        $(this.target).on('input', () => this.onChange());
    }

    public focusIn() {
        if (runtime.elements.steps.actual >= (this.react.option || 0) - 1) {
            $(this.list).removeClass('hide');
        } else {
            $(this.react.element).blur();
        }
    }

    public focusOut() {
        if ($(this.target).val() === '') {
            $(this.target).val(this.baseText);
        }

        setTimeout(() => {
            $(this.list).addClass('hide');
        }, 200);
    }

    public onChange() {
        this.react.setOption = String($(this.target).val() || '');
        runtime.elements.refreshSteps();
    }

    public onClick() {
        if (runtime.elements.steps.actual >= (this.react.option || 0) - 1) {
            $(this.target).val('');
        }
    }
}

export class Language extends BaseElement {
    public options: BaseElement[];

    constructor(element?: Element) {
        super(element);
        this.options = [];
    }

    public afterSet() {
        $(this.element).find('li').each((index, element) => {
            const option = new BaseElement(element as Element);

            option.onClick = () => {
                const language = String($(element).attr('class') || '');
                const queryParts = window.location.search
                    .replace(/^\?/, '')
                    .split('&')
                    .filter((part) => part.length > 0)
                    .filter((part) => !/^(cs|sk|en|de)$/.test(part));
                const separator = queryParts.length > 0 ? '&' + queryParts.join('&') : '';

                runtime.query.replaceUrl(window.location.origin + window.location.pathname + '?' + language + separator);
                throw '';
            };

            this.options.push(option);
        });
    }
}

export class Step extends BaseElement {
    public stav: boolean;
    public option: number;
    public name: string;
    public parent: Element;
    public label: Element;
    public labelOriginal: string;
    public setOption: string;

    constructor(element?: Element) {
        super(element);
        this.stav = false;
        this.option = 0;
        this.name = '';
        this.labelOriginal = '';
        this.setOption = '';
    }

    public onClick(event: any = null) {
        const target = $(event.target).closest('li');
        const optionValue = String(target.attr('data-value') || target.attr('data-product') || target.attr('class') || '');

        if (optionValue.length === 0) {
            return;
        }

        $(this.label).html(this.truncate(String(target.text() || '')));
        $(this.parent).removeClass('deactive').addClass('active');

        const changed = this.setOption !== optionValue;
        this.setOption = optionValue;

        if (this.option >= runtime.elements.steps.options.length) {
            const href = runtime.elements.buildHelpHref(this.setOption);

            if (href !== undefined) {
                runtime.query.redirectUrl(href);
            }

            return;
        }

        if (changed) {
            runtime.elements.resetStepsAfter(this.option);
        }

        runtime.elements.steps.actual = this.option;
        runtime.elements.refreshSteps();
    }

    public afterSet() {
        this.stav = true;
        this.parent = $(this.element).parents('.input')[0];
        this.label = $(this.parent).children('li')[0];
        this.labelOriginal = String($(this.label).html() || '');
        this.name = String($(this.label).attr('class') || '');

        const children = $(this.element).children();
        children.on('click', (event) => this.onClick(event));

        ($(this.parent).attr('class') || '').split(' ').forEach((className) => {
            if (className.indexOf('step') === 0) {
                this.option = parseInt(className.substr(4, 5), 10);
            }
        });

        runtime.elements.addSteps(this);
    }

    public truncate(text: string): string {
        if (text.length > 44) {
            return text.substring(0, 34) + '...';
        }

        return text;
    }
}
